<div [formGroup]="group">
  <input type="hidden" [formControlName]="config.name" />
</div>
